module.exports = __webpack_public_path__ + "static/media/escaperoute.66fe0bdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/escaperoute.png
// module id = 590
// module chunks = 0